import { connect } from 'dva'
import { bindActionCreators } from 'redux'

import * as actions from 'models/app/actions'

import Welcome from './Welcome'

function mapStateToProps(state, ownProps) {
  return {}
}

function mapDispatchToProps(dispatch) {
  const boundActions = bindActionCreators(actions, dispatch)

  return {
    start: boundActions.start
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome)



// WEBPACK FOOTER //
// ./src/components/Welcome/index.js